// Central content config for the CRAYFOX booking site.
// Swap placeholder URLs (socials, contact email) with the band's real links here.

export const ASSETS = {
  logo: "https://customer-assets-jai6qajn.emergentagent.net/job_98b4f40c-6cae-44d9-8446-fb985ba208ad/artifacts/fp5ff7l0_Booking%20crayfox.JPG",
  portraitBW: "https://customer-assets-jai6qajn.emergentagent.net/job_98b4f40c-6cae-44d9-8446-fb985ba208ad/artifacts/mijuqutu_Crayfox_SW.jpg",
  livePyro: "https://customer-assets-jai6qajn.emergentagent.net/job_98b4f40c-6cae-44d9-8446-fb985ba208ad/artifacts/nombhmv2_crayfox_live%20band.jpg",
  bassist: "https://customer-assets-jai6qajn.emergentagent.net/job_98b4f40c-6cae-44d9-8446-fb985ba208ad/artifacts/rfnlqvdn_CRAYfox.JPG",
  vocals: "https://customer-assets-jai6qajn.emergentagent.net/job_wave-band-events/artifacts/7qjk061r_Crayfox_02.JPG",
  guitar: "https://customer-assets-jai6qajn.emergentagent.net/job_wave-band-events/artifacts/01e70w6n_PHOTO-2026-09-02-20-43-22.jpg",
  drums: "https://customer-assets-jai6qajn.emergentagent.net/job_wave-band-events/artifacts/ukfz5r4g_Marko.jpg",
  producer: "https://customer-assets-jai6qajn.emergentagent.net/job_wave-band-events/artifacts/xaho716d_PHOTO-2026-10-01-09-49-23.jpg",
  collage: "https://customer-assets-jai6qajn.emergentagent.net/job_98b4f40c-6cae-44d9-8446-fb985ba208ad/artifacts/stm9kn1a_Crayfox.png",
  tourBg: "https://customer-assets-jai6qajn.emergentagent.net/job_wave-band-events/artifacts/j0ufs1s2_tour%20foto.webp",
  brandLogo: "https://customer-assets-jai6qajn.emergentagent.net/job_wave-band-events/artifacts/1y1nfwiq_crayfox%20logo.jpg",
  promoVideo: "/promo.mp4",
};

export const CONTACT_EMAIL = "swalpu80@gmail.com";

export const SOCIALS = [
  { id: "facebook", label: "Facebook", url: "https://www.facebook.com/crayfox.band" },
  { id: "youtube", label: "YouTube", url: "https://www.youtube.com/c/Crayfox" },
  { id: "backstage", label: "BackstagePRO", url: "https://www.backstagepro.de/crayfox", text: "BS" },
];

export const NAV_LINKS = [
  { id: "history", label: "History" },
  { id: "tour", label: "Tour Dates" },
  { id: "lineup", label: "Lineup" },
  { id: "producer", label: "Producer" },
  { id: "rider", label: "Tech Rider" },
];

export const MARQUEE_ITEMS = [
  "CRAYFOX LIVE",
  "ROCK × POP-METAL × WAVE",
  "BOOKINGS OPEN 2026/27",
  "STAGE ON FIRE",
  "RAW POWER — UNFORGIVING ENERGY",
];

export const TOUR_DATES = [
  { iso: "2027-03-06", city: "Tettnang", venue: "Im Flieger", country: "DE", type: "Club Show", status: "confirmed" },
  { iso: "2027-06-21", city: "Kamenz", venue: "Fête de la Musique", country: "DE", type: "Festival", status: "festival" },
  { iso: "2027-06-26", city: "Hauswalde", venue: "Rocknacht", country: "DE", type: "Private Event", status: "confirmed" },
  { iso: "2027-08-28", city: "Ohorn", venue: "Rock im Wald", country: "DE", type: "Festival", status: "festival" },
  { iso: "2027-09-01", city: "Großröhrsdorf", venue: "XXL Rocknacht", country: "DE", type: "Club Show", status: "confirmed", tbc: true },
];

export const MEMBERS = [
  {
    name: "Beatrix",
    role: "Lead Vocals",
    stage: "Center Stage",
    gear: ["Shure SM58 capsule / wireless", "Sennheiser EW IEM"],
    photo: ASSETS.vocals,
  },
  {
    name: "Steve",
    role: "Lead Guitar",
    stage: "Stage Left",
    gear: ["Black Falcon Gretsch (Japan)", "Quad Cortex AMP", "Bariton Falcon"],
    photo: ASSETS.guitar,
  },
  {
    name: "Mirko",
    role: "Bass & Backing Vocals",
    stage: "Stage Right",
    gear: ["Sandberg California 4-string", "Ampeg SVT-CL + 8x10", "Zoom B2-4"],
    photo: ASSETS.bassist,
  },
  {
    name: "Marko",
    role: "Drums & Triggers",
    stage: "Drum Riser",
    gear: ["Pdp Pacific Cs by DW", "Paiste Alpha, Istanbul", "Ddrum 4"],
    photo: ASSETS.drums,
  },
];

export const HISTORY_TIMELINE = [
  { year: "2004", text: "Founded in the Dresden / Lusatia area — grown from a late-2003 studio project into a live band." },
  { year: "2006", text: "Debut album “Rise” and the first Rockharz festival appearance." },
  { year: "2010", text: "Split at the end of the year — the members follow different musical paths." },
  { year: "2015", text: "Reactivation with new members. CRAYFOX returns to the stage." },
  { year: "2026", text: "Booking now open for the 2026/27 club & festival cycle." },
];

export const SOUND_BADGES = [
  "Rock",
  "Pop-Metal",
  "Wave",
  "Gothic Rock",
  "Full Pyro Show",
  "45–90 min Sets",
];

export const RIDER_CHANNELS = [
  { ch: 1, source: "Kick In", mic: "Shure Beta 91A", notes: "—" },
  { ch: 2, source: "Kick Out", mic: "AKG D112 / e602", notes: "Short boom" },
  { ch: 3, source: "Snare Top", mic: "SM57", notes: "—" },
  { ch: 4, source: "Snare Bottom", mic: "SM57", notes: "—" },
  { ch: 5, source: "Hi-Hat", mic: "KM184 / C451", notes: "—" },
  { ch: 6, source: "Rack Tom", mic: "Sennheiser e604", notes: "—" },
  { ch: 7, source: "Floor Tom", mic: "Sennheiser e604", notes: "—" },
  { ch: 8, source: "Overhead L", mic: "C414 / LDC", notes: "Tall stand" },
  { ch: 9, source: "Overhead R", mic: "C414 / LDC", notes: "Tall stand" },
  { ch: 10, source: "Bass DI", mic: "Active DI", notes: "Post-pedalboard" },
  { ch: 11, source: "Bass Mic", mic: "e902 / D112", notes: "Optional, 8x10 cab" },
  { ch: 12, source: "Guitar L", mic: "e906 / SM57", notes: "Mesa 4x12" },
  { ch: 13, source: "Guitar R (Double)", mic: "e906 / SM57", notes: "Optional 2nd cab" },
  { ch: 14, source: "Vox FX Return", mic: "Line / DI", notes: "VoiceLive out" },
  { ch: 15, source: "Lead Vox", mic: "SM58 (wireless pref.)", notes: "Center stage" },
  { ch: 16, source: "Backing Vox", mic: "SM58", notes: "Stage right" },
];

export const RIDER_MONITORS = [
  "Mix 1 — Lead Vocals: center wedge or IEM (own Sennheiser EW IEM rack)",
  "Mix 2 — Guitar: stage-left wedge, vocal-heavy",
  "Mix 3 — Bass: stage-right wedge, kick + vox focus",
  "Mix 4 — Drums: drumfill + sidefill, click via IEM (own splitter)",
];

export const RIDER_PA = [
  "PA sized to venue capacity; min. 2x 18\" subs per side for 300+ cap rooms",
  "Digital FOH desk: X32 / M32 / SQ-5 or better",
  "230V / 16A power drops: stage left, stage right, drum riser",
  "Stage min. 6m x 4m; drum riser 3m x 2m (min. 40cm height)",
  "Lighting: we travel with a floor package — strobes & red wash very welcome",
];

export const RIDER_BACKLINE = [
  "Full backline travels with the band (amps, drums, IEM rack)",
  "For fly-dates / festivals: drum kit + bass amp on request",
  "Set length: 45–90 min; changeover: 25 min with own crew",
  "Pyro (cold spark fountains) available for outdoor / approved venues",
];
